let variantsButton = document.querySelectorAll('variant-selection .options-selection__option-value');
let inventoryThreshold = +document.querySelector('variant-selection .options-selection__option-values').getAttribute('data-inventory-threshold');

function disableButtons(time){
  setTimeout(()=>{
    variantsButton.forEach(button => {
      let input = button.querySelector('.options-selection__option-value-input');
      let variantInventory = +input.getAttribute('data-custom-variant-inventory');

      if(variantInventory < inventoryThreshold || variantInventory === inventoryThreshold) {
        button.classList.remove('options-selection__option-value--selected');
        input.setAttribute('custom-disabled','');
        input.setAttribute('data-variant-option-accessible','false');
        input.setAttribute('data-variant-option-available','false');
      }
    });
  },time);
}

disableButtons(500);

variantsButton.forEach(button => {
  let input = button.querySelector('.options-selection__option-value-input');
  input.addEventListener('click', () => {
    disableButtons(0);
  })
})